export function isCurrentByEndDate(endDate: string | null | undefined, todayIso: string): boolean {
  if (!endDate) return true;
  return endDate >= todayIso;
}
